import './App.css';
import ImageCarousel from "./imageCarousel";

function Home() {
  return (
      <div className="contentDiv">
        <h1 className="contentHeader">Who we are</h1>
        <p> 
          Lobo Powerlifting is dedicated to giving students at the University of New Mexico the opportunity to compete in the sport of powerlifting at the collegiate level.
          Our mission is to grow the powerlifting community in New Mexico while fostering a supportive yet competitive environment for lifters of all experience levels. 
          We proudly compete under the Powerlifting America (PA) federation, with members representing UNM at PA University Nationals each spring and at various local meets throughout the year.
        </p>
      </div>
  );
}

export default Home;
